module.exports = __webpack_public_path__ + "09afc46a.svg";